export { default as DetalleCierre } from "./DetalleCierre";
